/****************************************************
 * Module Name:  AddCompanyModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, CircularProgress, Tooltip, Typography, IconButton, Badge, Avatar, Menu, Fade, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Utility from "../../../utility/utility";
import TenderCompanyProxy from "../../../utility/proxy/manager/manufacturingProxy/tenderCompanyProxy";
import CommonSnackbar from "../../common/commonSnackBar";
import PhoneInput from "react-phone-input-2";


export default class AddCompanyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newname: this.props.editOperation
                ? this.props.sourceData.name
                : "",
            newlogo: this.props.editOperation
                ? this.props.sourceData.logo
                : "",

            newselectedfilename: this.props.editOperation
                ? this.props.sourceData.selectedfilename
                : "",

            newphonecode: this.props.editOperation
                ? this.props.sourceData.phonecode
                : "91",

            newcontactno: this.props.editOperation
                ? this.props.sourceData.contactno
                : "",
            newemail: this.props.editOperation
                ? this.props.sourceData.email
                : "",

            showError: false,
            showValidationMessage: false,
            validateCompanyNamePresentSpinner: false,
            companyNameAvailable: true,

            nameValidationError: "",

            warning: false,
            warningmessage: "",

            error: false,
            errorMessage: "",

            changingPhoto: false,
            anchorEl: null,
            open: false,
            inputRef: React.createRef(),
            emailError: "",

            defaultCountryForPhoneCode: this.props.editOperation ? this.props.sourceData.phonecode : "in",
        };
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };


    handleSave = () => {
        let phonecode = this.state.newcontactno.length > 0 ? this.state.newphonecode : null;
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            name: this.state.newname,
            phonecode: phonecode,
            contactno: this.state.newcontactno,
            email: this.state.newemail,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data, this.state.newlogo, this.state.changingPhoto);
                else
                    this.setState({
                        showError: true,
                    });
            } else
                this.props.handleSave(data, this.state.newlogo, this.state.changingPhoto);
        }
    };

    validateCompanyNamePresent = (companyNameEntered) => {
        if (!companyNameEntered || companyNameEntered.trim() === "") return;

        this.setState({
            validateCompanyNamePresentSpinner: true,
        });
        let companyName = this.props.sourceData.name ? this.props.sourceData.name : "";
        if (companyName.toLowerCase().trim() !== companyNameEntered.toLowerCase().trim()) {
            TenderCompanyProxy.CheckCompanyNameAvailable(companyNameEntered, (response) => {
                //if we got response that means companyname is present at backend
                if (response) {
                    this.setState({
                        validateCompanyNamePresentSpinner: false,
                        showValidationMessage: true,
                        companyNameAvailable: false,
                    });
                } else {
                    this.setState({
                        validateCompanyNamePresentSpinner: false,
                        showValidationMessage: true,
                        companyNameAvailable: true,
                    });
                }
            });
        } else {
            this.setState({
                validateCompanyNamePresentSpinner: false,
                companyNameAvailable: "",
                showValidationMessage: false,
            });
        }
    };

    buttonDisable = () => {
        const hasValidationErrors =
            !this.state.newname ||
            this.state.error

        return hasValidationErrors;
    };

    handleRefClickPhoto = () => {
        this.state.inputRef.current.click();
        this.setState({
            anchorEl: null,
            open: null,
        });
    };

    handleRemoveProfile = () => {
        this.setState({
            newlogo: null,
            anchorEl: null,
            changingPhoto: true,
            open: false,
            error: false,
        })
    };

    handleMenuClose = (e) => {
        this.setState({
            anchorEl: null,
            open: false
        })
    };

    handleClick = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
            open: Boolean(event.currentTarget)
        })
    };

    handlePhotoChange = (event) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }

        if (event.target.files[0].size > 1024000) {
            this.setState({
                error: true,
            });
        } else {
            this.setState({
                error: false,
            });
        }
        this.setState({
            newlogo: event.target.files[0],
            changingPhoto: true,
        });

        event.target.value = null;
    };

    render() {
        return (
            <Box>
                <input
                    type="file"
                    ref={this.state.inputRef}
                    onInputCapture={this.handlePhotoChange}
                    hidden
                    accept="image/*"
                />
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add company validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <CommonSnackbar
                    show={this.state.warning}
                    message={this.state.warningmessage}
                    variant={"warning"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Warning"}
                    handleClose={() => {
                        this.setState({
                            warning: false,
                            warningmessage: ""
                        })
                    }}
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Company" : "Add New Company"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <td colSpan={2} style={{ textAlign: "center" }}>
                                        <Box width={"12%"} marginLeft={"40%"} >
                                            <Tooltip title="Change Photo">
                                                <IconButton
                                                    onClick={this.handleClick}
                                                    size="small"
                                                    sx={{ ml: 2 }}
                                                    aria-controls={this.state.open ? "account-menu" : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={this.state.open ? "true" : undefined}
                                                >
                                                    <Badge
                                                        overlap="circular"
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                        badgeContent={
                                                            <Avatar sx={{ width: 30, height: 30, opacity: 0.9 }}>
                                                                <EditRoundedIcon />
                                                            </Avatar>
                                                        }
                                                    >
                                                        <Avatar
                                                            sx={{ width: 100, height: 100, fontSize: "6rem" }}
                                                            src={
                                                                this.state.newlogo && this.state.newlogo !== null
                                                                    ? this.state.changingPhoto
                                                                        ? URL.createObjectURL(this.state.newlogo)
                                                                        : `data:image/png;base64, ${this.state.newlogo}`
                                                                    : require("../../../images/defaultlogo.png")
                                                            }
                                                        >
                                                        </Avatar>
                                                    </Badge>
                                                </IconButton>
                                            </Tooltip>
                                            <Menu
                                                anchorEl={this.state.anchorEl}
                                                id="account-menu"
                                                open={this.state.open}
                                                TransitionComponent={Fade}
                                                onClose={this.handleMenuClose}
                                                onClick={this.handleMenuClose}
                                            >
                                                <MenuItem onClick={this.handleRefClickPhoto}>
                                                    <ListItemIcon>
                                                        <AddAPhotoIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    Upload Photo
                                                </MenuItem>
                                                {this.state.newlogo && (
                                                    <MenuItem onClick={this.handleRemoveProfile}>
                                                        <ListItemIcon>
                                                            <DeleteRoundedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        Remove Photo
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        </Box>
                                        <Typography
                                            variant="caption"
                                            display={this.state.error ? "block" : "none"}
                                            sx={{
                                                textAlign: 'center',
                                                marginTop: 1,
                                                color: 'red',
                                            }}
                                        >
                                            File size should be less than 1024kb
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Company Name <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Company Name (required)"
                                            placeholder="Enter Company Name"
                                            value={this.state.newname}
                                            onBlur={(e) =>
                                                this.validateCompanyNamePresent(e.target.value)
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    this.validateCompanyNamePresent(e.target.value)
                                                }
                                            }}
                                            onChange={(e) =>
                                                this.setState({
                                                    newname: e.target.value,
                                                    showValidationMessage: false,
                                                    nameValidationError: Utility.CheckIsPresent(
                                                        e.target.value
                                                    )
                                                        ? ""
                                                        : "Company Name Cannot be Empty",
                                                })
                                            }
                                            helperText={this.state.nameValidationError}
                                            error={this.state.nameValidationError.length > 0}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        {this.state.validateCompanyNamePresentSpinner ? (
                                            <CircularProgress size="1rem" />
                                        ) : !this.state.showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : this.state.companyNameAvailable ? (
                                            <font color="green">Company Name available</font>
                                        ) : (
                                            <font color="red">Company Name not available</font>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <table style={{ width: "100%" }}>
                                            <tr>
                                                <td style={{ width: "30%" }}>
                                                    <Form.Label style={{ margin: "0px", marginBottom: "8px" }}>Country Code</Form.Label>
                                                    <PhoneInput style={{ margin: "0px" }}
                                                        size="small"
                                                        key={this.state.newphonecode}
                                                        country={this.state.defaultCountryForPhoneCode}
                                                        enableSearch={true}
                                                        value={this.state.newphonecode}
                                                        defaultValue={this.state.newphonecode}
                                                        onChange={(phonecode) => {
                                                            this.setState({
                                                                newphonecode: phonecode,
                                                            });
                                                        }}
                                                        inputStyle={{
                                                            width: "110px",
                                                            height: "37px",
                                                            fontSize: "14px",
                                                        }}
                                                        inputProps={{
                                                            onKeyDown: (e) => e.preventDefault(),
                                                            placeholder: "",
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ width: "52%" }}>
                                                    <Form.Label style={{ margin: "0px", marginBottom: "8px" }}>Contact No</Form.Label>
                                                    <TextField style={{ margin: "0px" }}
                                                        margin="normal"
                                                        size="small"
                                                        fullWidth
                                                        label="Contact No"
                                                        placeholder="Enter Contact No"
                                                        value={this.state.newcontactno}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                newcontactno: e.target.value,
                                                            })
                                                        }
                                                        inputProps={{
                                                            style: {
                                                                width: "100%",
                                                            },
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Email
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Email"
                                            placeholder="Enter Email"
                                            value={this.state.newemail}
                                            autoFocus
                                            onChange={(e) => {
                                                const email = e.target.value;
                                                this.setState({ newemail: email });

                                                if (!Utility.CheckIsEmail(email)) {
                                                    this.setState({ emailError: "Invalid email address" });
                                                } else {
                                                    this.setState({ emailError: "" });
                                                }
                                            }}
                                            error={Boolean(this.state.emailError)}
                                            helperText={this.state.emailError}
                                        />
                                    </td>
                                </tr>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        )
    }
}